import { DocumentListComponent } from './document-list.component';

export default angular
  .module('sfMobile.components.document-list', [])
  .component('sfDocumentList', DocumentListComponent).name;
